export default __webpack_public_path__ + "static/media/speakers__daniel-steinberg.d7730578.jpg";